"use client";

import { useState } from "react";
import { motion } from "framer-motion";
import { useLang } from "@/lib/LanguageContext";
import { FAQItem } from "@/components/pages/FAQPage";

const EASE = [0.22, 1, 0.36, 1] as const;
const COLORS = ["#FF419D", "#9B59F5", "#FFB76C"];

/** The questions people ask most before starting a website. */
export default function WebsitesFAQ() {
  const { t } = useLang();
  const f = t.websitesFaq;
  const [open, setOpen] = useState<number | null>(0);

  return (
    <section className="relative section-padding">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, ease: EASE }}
          className="max-w-3xl mx-auto"
        >
          <div className="text-center mb-8 sm:mb-12">
            <span className="inline-block text-[11px] sm:text-xs font-bold tracking-[0.25em] uppercase mb-5 text-[#f472b6]">
              {f.label}
            </span>
            <h2 className="font-display font-extrabold text-3xl sm:text-4xl md:text-5xl text-white leading-[1.08] tracking-tight">
              {f.title} <span className="text-gradient-warm whitespace-nowrap">{f.titleAccent}</span>
            </h2>
          </div>

          <ul className="border-t border-white/[0.07]">
            {f.items.map((item, i) => (
              <FAQItem
                key={item.q}
                id={`websites-faq-${i}`}
                question={item.q}
                answer={item.a}
                color={COLORS[i % COLORS.length]}
                open={open === i}
                onToggle={() => setOpen(open === i ? null : i)}
              />
            ))}
          </ul>
        </motion.div>
      </div>
    </section>
  );
}
